module.exports = __webpack_public_path__ + "static/bookshelf-nav-square-e79b54d34af8e494ed1bbb698b689613.jpeg";